var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import Cookies from 'js-cookie';
import { ShareValues } from '../helpers/ShareValues';
import { EXPIRATION_TOKEN_KEY, DEVELOPMENT_MODE, } from '../constants/constants';
import { logger } from '../helpers/Log';
import { setCacheAuth0Result } from '../helpers/secureCache';
import { getCookieDomain } from '../helpers/utils';
import { runningOnCanvas } from '../utils/canvas';
// clear old session if we're inside a canvas and the referer is launch-pad
if (runningOnCanvas() && (document.referrer.includes('launch-pad') || window.location.pathname.includes('callback')) && localStorage.length > 0) {
    console.log("c ".concat(localStorage.length, " (canvas+launch-pad)"));
    localStorage.clear();
}
var AuthContext = React.createContext({});
function AuthContextProvider(_a) {
    var children = _a.children;
    var _b = __read(useState(), 2), authResult = _b[0], setAuthResult = _b[1];
    var setAuthInformation = function (authInfo, fromCache) {
        var _a, _b;
        if (fromCache === void 0) { fromCache = false; }
        setAuthResult(authInfo);
        ShareValues.updateInstance(__assign(__assign({}, ShareValues.getData()), { authResult: authInfo }));
        if (authInfo) {
            var expirationDate = (_b = (_a = authInfo === null || authInfo === void 0 ? void 0 : authInfo.idTokenPayload) === null || _a === void 0 ? void 0 : _a.exp) !== null && _b !== void 0 ? _b : Math.floor(new Date(Date.now() + 12 * (60 * 60 * 1000)).getTime() / 1000);
            Cookies.set(EXPIRATION_TOKEN_KEY, String(expirationDate), {
                expires: 7,
                domain: getCookieDomain(),
            });
            if (DEVELOPMENT_MODE) {
                logger('Adding authResult to cache');
                setCacheAuth0Result(JSON.stringify(authInfo));
            }
            else if (!fromCache) {
                setCacheAuth0Result(JSON.stringify(authInfo), 900);
            }
        }
    };
    return (React.createElement(AuthContext.Provider, { value: {
            authResult: authResult,
            setAuthResult: setAuthInformation,
        } }, children));
}
export { AuthContextProvider, AuthContext };
//# sourceMappingURL=AuthContext.js.map